import type { PropsWithChildren } from 'react'
import { useEffect } from 'react'

import { withRouter } from 'react-router'

const ScrollToTopBase = (props: PropsWithChildren<any>) => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [props.location.pathname])

  return props.children || null
}

export const ScrollToTop = withRouter(ScrollToTopBase)
